import type { WorkflowStep } from "./reducer";

export default function stepShouldSwitchAutomatically({
  actions,
  shouldSwitchAutomatically,
}: WorkflowStep) {
  if (shouldSwitchAutomatically) {
    // BWS said
    return true;
  }

  if (
    actions.length === 1 &&
    actions.find(({ type }) => type === "SINGLE_FILE")
  ) {
    return true;
  }

  if (
    actions.length === 1 &&
    actions.find(({ type }) => type === "UPLOAD_FILESET")
  ) {
    return true;
  }

  return false;
}
